// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__uzQ7m","item":"PaymentsMobile_item__vACYm","label":"PaymentsMobile_label__nW9N7","amount":"PaymentsMobile_amount__yWrRT"};